module.exports = __webpack_public_path__ + "img/maruteru_syokudo.3b0477dd.jpg";